export default __webpack_public_path__ + "static/media/specialization_deeplearning.d8a7b095.png";